import { ReportUnit } from '@models';

export interface Metric {
  value: number;
  minimum?: number;
  unit: ReportUnit;
  id: string;
}
